import * as ActionType from '../actions/current-window-index';

const defaultState = {
	index: 0
};

/**
 * @description
 * get the setup data required for every page of the app.
 *
 * @param {Object} state
 * @param {Object} action
 * @returns {*}
 */
export default function currentWindow (state = defaultState, action) {

	switch (action.type) {

		case ActionType.SET_WINDOW_INDEX : {
			let newState = {...state};
			newState.index = action.index;
			return newState;
		}

		default:
			return state;
	}

}
